import { render } from "./UiField.vue?vue&type=template&id=3d235fca"
import script from "./UiField.vue?vue&type=script&lang=js"
export * from "./UiField.vue?vue&type=script&lang=js"

import "./UiField.vue?vue&type=style&index=0&id=3d235fca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__